import { VenlyConnect, WindowMode } from "@venly/connect"

export const VenlyService = new VenlyConnect(`${process.env.NEXT_PUBLIC_VENLY_WIDGET_CLIENT_ID}`, { environment: `${process.env.NEXT_PUBLIC_VENLY_WIDGET_MODE}`, windowMode: WindowMode.POPUP })
